/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Somenotificationcontrol2Inputs */

const en_settings_somenotificationcontrol2 = /** @type {(inputs: Settings_Somenotificationcontrol2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some notification controls below may apply to funds with roles you currently do not have access to, but you can still configure these settings in case you gain access in the future.`)
};

/**
* | output |
* | --- |
* | "Some notification controls below may apply to funds with roles you currently do not have access to, but you can still configure these settings in case you ga..." |
*
* @param {Settings_Somenotificationcontrol2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_somenotificationcontrol2 = /** @type {((inputs?: Settings_Somenotificationcontrol2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Somenotificationcontrol2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_somenotificationcontrol2(inputs)
});
export { settings_somenotificationcontrol2 as "settings_someNotificationControl" }